import { RouteComponentProps, withRouter } from 'react-router-dom'

import { branch, compose, renderComponent } from 'recompose'
import styled from 'styled-components'

import { SpendAccountStatus } from 'generated/types'
import Loading from 'pages/loading'
import { routes } from 'router/routes'

import withSpendCardStatus, {
  Props as CardStatusProps,
} from './withSpendCardStatus'

type Props = RouteComponentProps<{}> & CardStatusProps

export enum SpendStatus {
  eligibility = 'spendEligible',
  account = 'hasBankAccount',
}

const StyledLoading = styled(Loading)`
  z-index: 50;
`

// Redirects user that don't have an activated or shipped card
// back to the present screen
const withSpendRedirect = (
  redirect = '/',
  status: SpendStatus = SpendStatus.eligibility,
) =>
  compose(
    withRouter,
    withSpendCardStatus(({ cardStatusLoading, history, ...props }: Props) => {
      if (!cardStatusLoading && !props[status]) {
        if (props.spendAccount?.status === SpendAccountStatus.NotOpened) {
          if (!props.fundingSourceInfo?.verified) {
            history.replace(routes.settings.linkedAccounts)
          } else {
            history.replace(routes.spend.signup)
          }
        } else if (props.spendAccount?.status !== SpendAccountStatus.Open) {
          history.replace(routes.spend.index)
        } else {
          history.replace(redirect)
        }
      }
    }),
    branch<Props>(
      ({ cardStatusLoading }) => cardStatusLoading,
      renderComponent(StyledLoading),
    ),
  )

export default withSpendRedirect
